export const prefixUrl = 'https://kekpets.win';
